var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"color":"primary","loading":_vm.loadding},on:{"change":_vm.saveDebugMode},model:{value:(_vm.item.debug),callback:function ($$v) {_vm.$set(_vm.item, "debug", $$v)},expression:"item.debug"}})}
var staticRenderFns = []

export { render, staticRenderFns }